import { notificationEndpoints } from '@/api/apiEndpoint'
import { apiService } from './apiService'
import { DefaultResponse, PageResponse } from '@/common/types/common'
import { Notification } from '@/common/types/notification'

export interface ApplyCompanyUserInfo {
  isAccepted: boolean | null;
  isExpired: boolean;

  companyId: number;
  companyName: string;
  companyLogo?: string;
  userName: string;
  userPhone: string;
  userEmail: string;

  rejectReason?: string;

  services?: {
    serviceType: string;
    roles: {
      id: number;
      name: string;
    }[]
  }[];

}


export const notificationService = {
  getNotifications: async (
    page: number,
    limit: number = 10,
    type?: 'TASK' | 'NOTIFICATION',
    serviceId?: number
  ) => {
    const response = await apiService.get<PageResponse<Notification>>(
      notificationEndpoints.getNotifications(page, limit, type, serviceId)
    )
    return response
  },

  getApplyCompanyUser: async (notificationId: string): Promise<ApplyCompanyUserInfo | null> => {
    try {
      const response = await apiService.get<ApplyCompanyUserInfo>(
        notificationEndpoints.getApplyCompanyUser(notificationId)
      )
      return response;
    } catch (error) {
      console.error(error)
      return null;
    }
  },

  acceptApplyCompanyUser: async (notificationId: string, roleIds: number[]): Promise<DefaultResponse> => {
    const response = await apiService.patch<DefaultResponse>(notificationEndpoints.acceptApplyCompanyUser(notificationId), { roleIds })
    return response;
  },
  rejectApplyCompanyUser: async (notificationId: string, reason: string): Promise<DefaultResponse> => {
    const response = await apiService.patch<DefaultResponse>(notificationEndpoints.rejectApplyCompanyUser(notificationId), { reason })
    return response;
  }
}
